<template>
    <div v-if="message || errors" class="alert alert-danger" role="alert">
        <p v-if="message">{{ message }}</p>
        <ul v-if="errors">
            <li v-for="(error, index) in errors" v-bind:key="`error-${index}`">{{ error[0] }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'form-error-list',
        props: {
            message: String,
            errors: Object,
        },
    };
</script>

<style scoped>

</style>
